export interface UndoStack<T> {
  push(item: T): void
  /** Pops and returns the top item, or undefined if at most one item remains (matches the legacy `<= 1` guard). */
  undo(): T | undefined
  /** Legacy semantics: true only when more than one snapshot exists. */
  canUndo(): boolean
  size(): number
  /** Returns a shallow copy of the current items (for optimistic-rollback checkpoints). */
  capture(): T[]
  /** Replaces the items with a copy of the given snapshot. */
  restore(items: T[]): void
}

export function createUndoStack<T>(): UndoStack<T> {
  const items: T[] = []
  return {
    push(item) {
      items.push(item)
    },
    undo() {
      if (items.length <= 1) return undefined
      return items.pop()
    },
    canUndo() {
      return items.length > 1
    },
    size() {
      return items.length
    },
    capture() {
      return [...items]
    },
    restore(snapshot) {
      items.splice(0, items.length, ...snapshot)
    },
  }
}
